export class Adjustment {
    public adjustmentId: number;
    public quoteId: number;
    public sequenceNumber: number;
    public baseAdjustmentPercent: number;
    public baseAdjustmentFlat: number;
    public optionsAdjustmentPercent: number;
	public modifiedBy: string;
	public quoteRevisionNumber: number;

    constructor() {
        this.baseAdjustmentPercent = 70.00;
        this.sequenceNumber = 1;
        this.baseAdjustmentFlat = 0;
		this.optionsAdjustmentPercent = 0.00;
		this.quoteRevisionNumber = null;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/model/adjustment.ts